import { isCommentsLink } from './blogCommentsLink'

// Generous, so the island has usually mounted (and fetched) by the time the
// reader gets there. Above too: a reload can restore the scroll below it.
const ROOT_MARGIN = '1200px 0px'

/**
 * Blog posts are SEO landing pages, and most readers never reach the
 * comments at the end. So React and the comments island load only when the
 * section nears the viewport, or at once when the link points at the
 * comments (the login round-trip, admin "View" links).
 */
export function BlogShowView() {
  const container = document.querySelector<HTMLElement>('#ts__blog_comments[data-react-app-src]')
  const src = container?.dataset.reactAppSrc

  if (!container || !src) {
    return
  }

  if (isCommentsLink(window.location.hash) || !('IntersectionObserver' in window)) {
    loadReactApp(src)
    return
  }

  const observer = new IntersectionObserver(
    function loadWhenNear(entries) {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect()
        loadReactApp(src)
      }
    },
    { rootMargin: ROOT_MARGIN },
  )
  observer.observe(container)
}

function loadReactApp(src: string) {
  if (document.querySelector(`script[src="${src}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.type = 'module'
  script.src = src
  document.head.appendChild(script)
}
